// eslint-disable-next-line no-unused-vars
const prod = {
  url: {
    KEYCLOAK_BASE_URL: 'https://id.sitecenter.org',
    API_BASE_URL: 'https://my.sitecenter.org',
    OMDB_BASE_URL: 'https://www.omdbapi.com',
    AVATARS_DICEBEAR_URL: 'https://api.dicebear.com/6.x',
  },
  keycloakInit: {
    url: "https://id.sitecenter.org",
    realm: "sitecenter",
    clientId: "sitecenter-web",
  }
}
export const config = prod
